import React from 'react'
// libs
import { useMutation } from '@apollo/client/react'
// components
import { PopoverModal } from 'components/UI'
// constants
import { Modals } from 'constants/modals'
// hooks
import { useShowModal } from 'hooks/index'
// graphql
import { DELETE_ACTIVE_DIRECTORY } from 'graphql/active-directory/mutations'
import { GET_ACTIVE_DIRECTORIES_QUERY } from 'graphql/active-directory/queries'
// views
import { DotsIcon, TableCell } from 'themes/views/tables'
// view components
import Menu from './Menu'
// types
import { IToken } from 'types/graphql'

const MODAL_PROPS = {
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'right' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'right' as const
  }
}

interface Props {
  token: IToken
}

const ActionsMenu: React.FC<Props> = ({ token }) => {
  const [deleteActiveDirectory] = useMutation(DELETE_ACTIVE_DIRECTORY)

  const { showModal } = useShowModal({ modalType: Modals.CONFIRM_DELETE_MODAL })

  const onDeleteConfirm = async () => {
    await deleteActiveDirectory({
      variables: { input: { tokenId: token.id } },
      refetchQueries: [GET_ACTIVE_DIRECTORIES_QUERY]
    })
  }

  const handleDeleteClick = () =>
    showModal({
      handleConfirm: onDeleteConfirm
    })

  return (
    <TableCell size={5}>
      <PopoverModal {...MODAL_PROPS} trigger={<DotsIcon />}>
        {({ closePopup }) => <Menu token={token} closePopup={closePopup} handleDeleteClick={handleDeleteClick} />}
      </PopoverModal>
    </TableCell>
  )
}

export default ActionsMenu
